import { Badge } from '@/components/ui/badge';
import type { Theme } from './types';

type Props = {
  themes: Theme[];
};

function relevanceVariant(relevance: string): 'default' | 'secondary' | 'outline' {
  if (relevance === 'high') return 'default';
  if (relevance === 'medium') return 'secondary';
  return 'outline';
}

export function ReviewThemes({ themes }: Props) {
  if (themes.length === 0) return null;

  return (
    <div>
      <h3 className="text-sm font-medium mb-2">Temi ricorrenti</h3>
      <div className="flex flex-wrap gap-2">
        {themes.map((theme, i) => (
          <Badge key={i} variant={relevanceVariant(theme.relevance)}>
            {theme.label}
          </Badge>
        ))}
      </div>
    </div>
  );
}
